module.exports = __webpack_public_path__ + "static/media/sorting.d7d9b101.svg";